<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from '../Member/Header.svelte';
    import HeaderThemes from '../Member/HeaderThemes.svelte';
    import Footer from '../Member/Footer.svelte';
    import FooterThemes from '../Member/Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faCopy,faStroopwafel,faHandHoldingDollar,faUser,faUserFriends,faLink,faDollarSign } from '@fortawesome/free-solid-svg-icons';
    import Swal from 'sweetalert2'
    import Time from "svelte-time";


    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = true
    let afflist

    async function getReport() {
        loading = true
        const res = await fetch(window.localStorage.getItem("apiurl")+"affiliate/affiliatereport", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            loading = false
            afflist = json.payload
		} else {
            loading = false
            throw new Error(json);
		}
    }
    let promise
    
    $: {
        promise = getReport()
    }
    // saveWithdraw()
    

</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-3" ><h4 style="color: rgb(230, 196, 119) !important;">แนะนำเพื่อน</h4></div>
    <div class="col-12 text-center mt-3 mb-2 ">
        <div class=" bg-dk p-2 rounded">
            <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate')}>สรุป</button>
            <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate/downline')}>รายงานลำดับชั้น</button>
            <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate/report')}>รายงานรายได้</button>
            <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2" on:click={() => push('/affiliate/history')}>รายการถอนเงิน</button>
        </div>
        
    </div>
    <div class="col-12" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        {#await promise}
        {:then number}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center text-white">
                <h6><Fa icon={faDollarSign} size="sm" /> รายงานรายได้</h6>
                {#each afflist as datalist, i}
                <div class="shadow-lg rounded p-2 text-center mb-2" style="background: linear-gradient(135deg, rgb(0, 0, 0) 0%, rgb(86, 80, 80) 50%, rgb(131, 120, 120) 51%, rgb(54, 50, 50) 71%, rgb(0, 0, 0) 100%); box-shadow: rgb(0, 0, 0) 5px 5px 10px !important; line-height: 30px; border-radius: 5px; padding: 2px 7px; color: gold;">
                    <div class="row">
                        <div class="col-4">
                            {datalist.member_username}<br />
                            {datalist.platform}
                        </div>
                        <div class="col-4">
                            {Number(datalist.affiliate_amount.toFixed(2)).toLocaleString("en-US")}<br />
                            {datalist.affiliate_desc}
                        </div>
                        <div class="col-4">
                            
                            <Time timestamp="{datalist.gentime*1000}" format="DD/MM/YYYY" />
                        </div>
                    </div>
                </div>
                {/each}
            </div>
        </div>
        {/await}
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-affs">
        <HeaderThemes/>
        <div class="col-12 text-center" ><h4  class="head-title">แนะนำเพื่อน</h4></div>
    <div class="col-12 text-center mt-1 mb-0 ">
        <div class=" bg-dk p-2 rounded">
            <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2  btn-affs" on:click={() => push('/affiliate')}>สรุป</button>
            <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2  btn-affs" on:click={() => push('/affiliate/downline')}>รายงานลำดับชั้น</button>
            <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2  btn-affs" on:click={() => push('/affiliate/report')}>รายงานรายได้</button>
            <button type="button" class="btn btn-outline-secondary btn-sm btn-gd btn-gd2  btn-affs" on:click={() => push('/affiliate/history')}>รายการถอนเงิน</button>
        </div>
        
    </div>
    <div class="col-12" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        {#await promise}
        {:then number}
        <div class="card mt-3 bg-black">
            <div class="card-body text-center text-white">
                <h6><Fa icon={faDollarSign} size="sm" /> รายงานรายได้</h6>
                {#each afflist as datalist, i}
                <div class="shadow-lg rounded p-2 text-center mb-2 mini-blog">
                    <div class="row">
                        <div class="col-4">
                            {datalist.member_username}<br />
                            {datalist.platform}
                        </div>
                        <div class="col-4">
                            {Number(datalist.affiliate_amount.toFixed(2)).toLocaleString("en-US")}<br />
                            {datalist.affiliate_desc}
                        </div>
                        <div class="col-4">
                            
                            <Time timestamp="{datalist.gentime*1000}" format="DD/MM/YYYY" />
                        </div>
                    </div>
                </div>
                {/each}
            </div>
        </div>
        {/await}
        {/if}
    </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd2{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.7rem;
        font-weight: 300;
    }
    .btn-gd{
        /* --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300; */
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
</style>